export default {
  settingWA: {}
}
